import { render, staticRenderFns } from "./SwitchEl.vue?vue&type=template&id=7f24dcfb&scoped=true&"
import script from "./SwitchEl.vue?vue&type=script&lang=ts&"
export * from "./SwitchEl.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchEl.vue?vue&type=style&index=0&id=7f24dcfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f24dcfb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
